<!-- 首页的商品组件 -->
<template>
    <div class="lby-goods-item" @click="goodsInfo">
        <div class="lby-fight">
            <img :src="fightpng"/>
            <span>{{goods.fightNumber==null?"0":goods.fightNumber}}战</span>
        </div>
        <div class="lby-other-item" style="color: #f3f169;"><span style="color: #f3f169;">属性值:</span>{{goods.attributeScore}}亿</div>
        <div class="lby-other-item"><span>神火:</span>{{goods.fireScore}}</div>
        <div class="lby-other-item"><span>封魔:</span>{{goods.relicScore}}</div>
        <div class="lby-other-item" :style="{color: goods.equipmentBless=='15'?'#f3f169':'white'}"><span>神佑:</span>{{goods.equipmentBless}}级</div>
        <div class="lby-other-item"><span>职业:</span>{{profession}}</div>
        <div class="lby-other-item" :style="{color: goods.primitive=='1'?'#f3f169':'white'}"><span>荒古套:</span>{{goods.primitive==1?"是":"否"}}</div>
        <div class="lby-other-item region-server"><span>区服:</span><div class="lby-content-inner">{{regionServer}}
        </div></div>
        <div class="lby-other-item"><span>简介:</span>
            <div class="lby-content-inner overflow-ellipsis"  @mouseover="showTip(goods.id)" @mouseleave="hideTip()">{{goods.title}}
            </div>
            <div class="nothover" :class="{hovertext:activeIndex===goods.id}">{{goods.title}}</div>
        </div>
        <div class="lby-other-item price"><span>价格:</span><span style="transform: scale(1.2);">{{goods.price}}￥</span></div>
        <div class="lby-other-item"><span>更新:</span>{{goods.updateTime}}</div>
    </div>
</template>

<script>
import fightpng from '@/assets/80fight.png'
export default {
  name: 'GoodsComponent',
  props: {
    goods: {
      default: () => {
        return {}
      }
    },
    pageNo: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      fightpng,
      activeIndex: -1
    }
  },
  methods: {
    showTip (id) {
      this.activeIndex = id
    },
    hideTip () {
      this.activeIndex = -1
    },
    goodsInfo () {
      this.$router.push({
        path: '/goodsinfo',
        query: {
          goodsId: this.goods.id,
          indexPageNo: this.pageNo
        }
      })
    }
  },
  computed: {
    regionName () {
      const regions = this.$store.state.basicdata.regionList
      const rs = regions.find(item => item.id === this.goods.region)
      if (rs == null) {
        return '未知'
      }
      return rs.name
    },
    serverName () {
      const servers = this.$store.state.basicdata.serverList
      const rs = servers.find(item => item.id === this.goods.server)
      if (rs == null) {
        return '未知'
      }
      return rs.serverName
    },
    regionServer () {
      if ((this.regionName + ':' + this.serverName).length > 20) {
        return (this.regionName + ':' + this.serverName).substring(0, 20) + '...'
      }
      return this.regionName + ':' + this.serverName
    },
    profession () {
      const rs = this.$profession.find(item => item.id === this.goods.profession)
      if (rs == null) {
        return '未知'
      }
      return rs.type
    }
  }
}
</script>

<style scoped lang="less">
.lby-goods-item{
    width: 250px;
    height: 350px;
    border-radius: 10px;
    border: 1px solid rgb(240, 240, 240);
    background: linear-gradient(to bottom, #053481,#277ac0, #4b5cbd);
    box-shadow: 0 0 2px #d3d3d3;
    color:rgb(150, 31, 31);
    flex-shrink: 0;
    margin-top: 20px;
    position: relative;
    .lby-fight{
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
        height: 80px;
        gap: 8px;
        margin-top: 10px;
        width: 100%;
        span{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 80px;
            font-size: 30px;
            color:white;
        }

    }
    .lby-other-item{
        width: 90%;
        color: white;
        display: flex;
        align-items: flex-start;
        padding-left: 25px;
        gap: 15px;
        font-size: 15px;
        text-align: left;
        margin-top: 3px;
        position: relative;
        span{
            font-size: 15px;
            color: #eee;
            font-weight: bold;
            width: 50px;
        }
        .lby-content-inner{
            width: 155px;
        }
        .nothover{
            display: none;
        }
        .hovertext {
            display: block;
            position: absolute;
            padding: 8px;
            border-radius: 4px;
            width: 150px;
            background-color:  rgba(100, 99, 99, 0.7);
            color: white;
            z-index: 999;
            top:20px;
            left:60px;
        }
    }
    .price{
        span{
          color:red;
        }
        color:red;
    }
    .region-server{
      height: 40px;
    }
}
.lby-goods-item:hover{
    cursor: pointer;
    box-shadow: 0px 0px 5px 5px #acaaaa;
}

</style>
